export function emptyFileFilters() {
  return {
    query: "",
    status: "",
    agent: "",
    fileType: "",
    from: "",
    to: "",
  };
}

function haystack(row) {
  return [
    row.name,
    row.email,
    row.phone,
    row.address,
    row.status,
    row.statusLabel,
    row.agent,
    row.fileType,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
}

export function filterFileIndex(rows = [], filters = emptyFileFilters()) {
  const query = String(filters.query || "").trim().toLowerCase();
  const from = filters.from ? Date.parse(filters.from) : null;
  const to = filters.to ? Date.parse(`${filters.to}T23:59:59`) : null;

  return rows.filter((row) => {
    if (query && !haystack(row).includes(query)) return false;
    if (filters.status && row.status !== filters.status) return false;
    if (filters.agent && row.agentId !== filters.agent && row.agent !== filters.agent) return false;
    if (filters.fileType && row.fileType !== filters.fileType) return false;
    if (from || to) {
      const when = Date.parse(row.when || "");
      if (!Number.isFinite(when)) return false;
      if (from && when < from) return false;
      if (to && when > to) return false;
    }
    return true;
  });
}

export function uniqueAgents(rows = []) {
  const seen = new Map();
  rows.forEach((row) => {
    if (!row.agentId && !row.agent) return;
    const key = row.agentId || row.agent;
    if (!seen.has(key)) seen.set(key, { id: row.agentId || row.agent, name: row.agent || row.agentId });
  });
  return [...seen.values()].sort((a, b) => String(a.name).localeCompare(String(b.name)));
}
